<template>
  <div class="body-wrapper">
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Serviseri
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="badge--mod far fas fa-toolbox"></i>
        </transition>
      </h1>
      <!-- <h2>{{ communityType }}</h2> -->
    </div>
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-if="!loading">
          <button @click="showModal('ModalContentAddContractor')" class="btn">
            Novi serviser
          </button>
          <select
            class="form-control custom-select"
            id="selecCategory"
            @change="categoryChange"
            v-model="selectedCategory"
          >
            <option value="-1">Sve kategorije</option>
            <option
              v-for="cat in categories"
              :key="cat.value.id"
              :value="cat.value.id"
              >{{ cat.text }}</option
            >
          </select>
          <data-table
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotNameActionCommunityContractors="'action'"
            @row-click="rowClick"
          ></data-table>
          <!-- :slotDatePost="'time'" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
import axios from '@/axios/axios.js';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      table: {
        tableColumns: [
          'name',
          'address_full_name',
          'description',
          'infrastructure_type',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            name: 'Naziv',
            address_full_name: 'Adresa',
            description: 'Opis',
            infrastructure_type: 'Kategorija',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje serviseri'
          },
          sortable: ['name']
        }
      },
      selectedCategory: -1,
      allContractors: [],
      categories: []
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    //loading data to table
    this.allContractors = await this.getAllContractors();

    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('far fa-newspaper');

    const categoriesResult = await axios.get(
      'infrastructure/infrastructure-types'
    );
    this.categories = categoriesResult.data.data.map(cat => {
      return {
        value: {
          id: cat.id,
          name: cat.name
        },
        text: cat.name
      };
    });
    this.setInfrastructureCategories(this.categories);
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened', 'loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', [
      'showModal',
      'showModalWider',
      'setInfrastructureCategories'
    ]),
    ...mapMutations('table', [
      'setTableBadge',
      'unsetTableData',
      'setTableData'
    ]),
    ...mapActions('table', ['getAllContractors']),

    back() {
      this.$router.back();
    },
    rowClick(data) {
      this.$router.push({
        name: 'contractorDetails',
        params: {
          contractorId: data.row.id
        }
      });
    },
    categoryChange() {
      this.loadingStarted();
      if (this.selectedCategory == -1) {
        this.setTableData(this.allContractors);
      } else {
        this.setTableData(
          this.allContractors.filter(
            contractor =>
              contractor.infrastructure_type_id == this.selectedCategory
          )
        );
      }
      this.loadingFinished();
    }
  }
};
</script>
<style lang="scss" scoped>
#selecCategory {
  position: absolute;
  right: 230px;
  z-index: 10;
  width: 180px;
  text-align: center;
  font-size: 1rem;
}
.body-wrapper {
  display: block;
  padding: 10px;

  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.btn:focus {
  box-shadow: none;
}
</style>
